import { InstructorProfileData } from '../../server/types'

import './style.scss'

interface InstructorProfileContentProps {
	profileData: InstructorProfileData
}

function InstructorProfileContent({profileData}: InstructorProfileContentProps) {

	return (
		<div className='section-content'>
			<div className='instructor-profile-content-section'>
				<div className='instructor-profile-content-title'>
					Meet your Instructor
				</div>
				{profileData.about_text &&
					<div className='instructor-profile-content-text'>
						{profileData.about_text.split('<p>').map((paragraph, index) => <p key={`aboutTxt${index}`}>{paragraph}</p>)}
					</div>
				}
			</div>
		</div>
	)
}

export default InstructorProfileContent
